import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { v4 as uuid } from "uuid";
import { number, object, string } from "yup";
import DropdownCmp2 from "../../../components/dropdown/DropdownCmp2";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import { GetEnumsResponse } from "../../../models/enum.model";
import {
  AddPbiReportGroupResponse,
  AddPbiReportRequest,
  GETReports,
  GetPbiReportsResponse,
} from "../../../models/pBIReport.model";
import { GetPermissionsSearchResponse } from "../../../models/permission.model";
import {
  AddPbiReport,
  EditPbiReport,
} from "../../../services/pBIReport.service";

const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};
interface Props {
  setOpenAddSubReportModal: (state: boolean) => void;
  openAddSubReportModal: boolean;
  addOrEdit: "Add" | "Edit";
  setUpdateReports: (state: string) => void;
  reportTypesOptions: GetEnumsResponse[];
  reportGroupsOptions: AddPbiReportGroupResponse[];
  reportAccessOptions: GetPermissionsSearchResponse[];
  subReport: GETReports;
  choosedReport: GetPbiReportsResponse;
}

const editReportValidationSchema = object().shape({
  title: string()
    .ensure()
    .required("لطفا نام فارسی را وارد نمایید")
    .max(150, "نام فارسی نباید بیش از ۱۵۰ کاراکتر باشد"),
  name: string()
    .ensure()
    .required("لطفا نام انگلیسی را وارد نمایید")
    .max(150, "نام انگلیسی نباید بیش از ۱۵۰ کاراکتر باشد"),
  orderIndex: number().required("لطفا ترتیب نمایش گزارش را وارد نمایید"),
});

const AddEditSubReportModal = ({
  setOpenAddSubReportModal,
  openAddSubReportModal,
  addOrEdit,
  setUpdateReports,
  reportTypesOptions,
  reportGroupsOptions,
  reportAccessOptions,
  subReport,
  choosedReport,
}: Props) => {
  const [reportTypeValue, setReportTypeValue] = useState<any>();
  const [reportGroupsValue, setReportGroupsValue] = useState<any>();
  const [reportAccessValue, setReportAccessValue] = useState<any>();

  const initialValues: AddPbiReportRequest = {
    title: addOrEdit === "Add" ? "" : subReport?.title,
    name: addOrEdit === "Add" ? "" : subReport?.name,
    orderIndex: addOrEdit === "Add" ? undefined : subReport?.orderIndex,
    pbiReportGroupId:
      addOrEdit === "Add" ? undefined : subReport?.pbiReportGroupId,
    pbiReportTypeId:
      addOrEdit === "Add" ? undefined : subReport?.pbiReportTypeId,
    permissionId: addOrEdit === "Add" ? undefined : subReport?.permissionId,
  };
  const { mutate: AddPbiReportMutate } = useMutation(AddPbiReport, {
    onSuccess: (data: GETReports) => {
      if (data) {
        setOpenAddSubReportModal(false);
        setUpdateReports(uuid());
        setReportAccessValue(undefined);
        setReportGroupsValue(undefined);
        setReportTypeValue(undefined);
      }
    },
    onError: () => {},
  });
  const { mutate: EditPbiReportMutate } = useMutation(EditPbiReport, {
    onSuccess: (data: boolean) => {
      if (data) {
        setOpenAddSubReportModal(false);
        setUpdateReports(uuid());
        setReportAccessValue(undefined);
        setReportGroupsValue(undefined);
        setReportTypeValue(undefined);
      }
    },
    onError: () => {},
  });

  const handleSelectedTypeDrop = (e: any) => {
    setReportTypeValue(e.target.value);
  };
  const handleSelectedGroupsDrop = (e: any) => {
    setReportGroupsValue(e.target.value);
  };
  const handleSelectedAccessDrop = (e: any) => {
    setReportAccessValue(e.target.value);
  };

  useEffect(() => {
    if (openAddSubReportModal) {
      setReportGroupsValue(choosedReport?.id);
      if (addOrEdit === "Edit") {
        setReportTypeValue(subReport?.pbiReportTypeId);
        setReportGroupsValue(subReport?.pbiReportGroupId);
        setReportAccessValue(subReport?.permissionId);
      }
    }
  }, [openAddSubReportModal]);

  const handleSubmitSubReport = (values: AddPbiReportRequest) => {
    if (addOrEdit === "Add") {
      AddPbiReportMutate({
        name: values.name,
        title: values.title,
        orderIndex: values.orderIndex,
        pbiReportTypeId: reportTypeValue,
        pbiReportGroupId: reportGroupsValue,
        permissionId: reportAccessValue,
      });
    } else {
      EditPbiReportMutate({
        name: values.name,
        title: values.title,
        orderIndex: values.orderIndex!,
        pbiReportTypeId:
          reportTypeValue !== undefined
            ? reportTypeValue
            : subReport.pbiReportTypeId,
        pbiReportGroupId:
          reportGroupsValue !== undefined
            ? reportGroupsValue
            : subReport.pbiReportGroupId,
        permissionId:
          reportAccessValue !== undefined
            ? reportAccessValue
            : subReport.permissionId,
        id: subReport.id,
      });
    }
  };
  return (
    <>
      <div>
        <Modal
          open={openAddSubReportModal}
          onClose={() => {
            setOpenAddSubReportModal(false);
            setReportAccessValue(undefined);
            setReportGroupsValue(undefined);
            setReportTypeValue(undefined);
          }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={deactiveUserStyle}>
            <Typography
              component={"p"}
              display={"block"}
              textAlign={"center"}
              fontWeight={"bold"}
              //   marginY={"3rem"}
              fontSize={"14px"}
              color={"#1D4A87"}
            >
              {addOrEdit === "Add" ? "افزودن گزارش" : "ویرایش گزارش"}
            </Typography>
            <>
              <Formik
                initialValues={initialValues}
                onSubmit={handleSubmitSubReport}
                validateOnMount={true}
                validationSchema={editReportValidationSchema}
              >
                {({
                  handleSubmit,
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid
                      container
                      gap={"2rem"}
                      marginTop={"15px"}
                      maxWidth={"400px"}
                    >
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          placeHolder={"عنوان فارسی گزارش"}
                          label={"عنوان فارسی گزارش"}
                          required={true}
                          name={"title"}
                          id={"title"}
                          value={values.title}
                          helperText={touched.title ? errors.title : ""}
                          error={touched.title && Boolean(errors.title)}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          placeHolder={"عنوان انگلیسی گزارش"}
                          label={"عنوان انگلیسی گزارش"}
                          required={true}
                          name={"name"}
                          id={"name"}
                          value={values.name}
                          helperText={touched.name ? errors.name : ""}
                          error={touched.name && Boolean(errors.name)}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          onKeyDown={(e) => {
                            if (
                              /^[آ-ی ء چ]+$/.test(e.key) &&
                              e.code !== "Space"
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} className="dropdownCmp2-container">
                        <DropdownCmp2
                          style={{
                            paddingRight: "0 !important",
                            // maxWidth: "300px",
                          }}
                          onChange={handleSelectedTypeDrop}
                          value={reportTypeValue}
                          label={"نوع گزارش*"}
                          options={reportTypesOptions}
                          name="pbiReportTypeId"
                          id="pbiReportTypeId"
                          darkTheme={true}
                          // defaultValue={dafaultDropdownValue}
                        />
                      </Grid>
                      <Grid item xs={12} className="dropdownCmp2-container">
                        <DropdownCmp2
                          style={{
                            paddingRight: "0 !important",
                            // maxWidth: "300px",
                          }}
                          onChange={handleSelectedGroupsDrop}
                          value={reportGroupsValue}
                          label={"گروه گزارش*"}
                          options={reportGroupsOptions}
                          name="pbiReportGroupId"
                          id="pbiReportGroupId"
                          darkTheme={true}
                          // defaultValue={dafaultDropdownValue}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MaterialTextFieldComponent
                          placeHolder={"ترتیب نمایش گزارش"}
                          label={"ترتیب نمایش گزارش"}
                          required={true}
                          name={"orderIndex"}
                          id={"orderIndex"}
                          value={values.orderIndex}
                          helperText={
                            touched.orderIndex ? errors.orderIndex : ""
                          }
                          error={
                            touched.orderIndex && Boolean(errors.orderIndex)
                          }
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyDown={(e) => {
                            if (/^(?![0-9]).*$/.test(e.key)) {
                              if (e.code !== "Backspace")
                                if (e.code !== "Delete") e.preventDefault();
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} className="dropdownCmp2-container">
                        <DropdownCmp2
                          style={{
                            paddingRight: "0 !important",
                            // maxWidth: "300px",
                          }}
                          onChange={handleSelectedAccessDrop}
                          value={reportAccessValue}
                          label={"دسترسی گزارش*"}
                          options={reportAccessOptions}
                          name="permissionId"
                          id="permissionId"
                          darkTheme={true}
                          // defaultValue={dafaultDropdownValue}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <Grid
                          container
                          justifyContent={"center"}
                          alignItems={"center"}
                          gap={1}
                          marginBottom={"8px"}
                        >
                          <Grid item xs={5} width={"100%"}>
                            <Button
                              fullWidth
                              type="submit"
                              variant="contained"
                              sx={{ borderRadius: "5px !important" }}
                              disabled={
                                !values.title ||
                                !values.name ||
                                !values.orderIndex
                              }
                              className={
                                !values.title ||
                                !values.name ||
                                !values.orderIndex
                                  ? "btnForm disabledBtn"
                                  : "btnForm SuccessDefault"
                              }
                            >
                              ثبت
                            </Button>
                          </Grid>
                          <Grid item xs={5} width={"100%"}>
                            <Button
                              fullWidth
                              variant="contained"
                              style={{
                                fontSize: "1rem",
                                color: "#fff",
                                height: "40px",
                                background: "#607D8B",
                              }}
                              sx={{ borderRadius: "5px !important" }}
                              onClick={() => {
                                setOpenAddSubReportModal(false);
                                setReportAccessValue(undefined);
                                setReportGroupsValue(undefined);
                                setReportTypeValue(undefined);
                              }}
                            >
                              انصراف
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default AddEditSubReportModal;
